import * as types from './mutation-types'

const mutations = {
	[types.SET_WINDOW_WIDTH](state,val) {
		state.windowW = val
	},
	[types.SET_PRODUCT](state,obj) {
		state.product = obj
	},
	[types.SET_LANG](state,str) {
		state.lang = str
	},
	[types.SET_PRODUCTSH](state,val) {
		state.productsH = val
	},
	[types.SET_PRODUCTLIST](state,arr) {
		state.prodctList = arr
	}
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js